import * as $ from 'jquery';
// manually trigger tooltips on hover
$('[data-trigger="manual"]').on('mouseover', function () {
    // show tooltip
    $(this).tooltip('show');
});
// auto hide tooltip when clicking outside zone
$(document).on("click", function (e) {
    let target = $(e.target);
    // ignore if clicking on tooltip or tooltip icon
    if (target.data("data-toggle") == "tooltip" || target.closest('[data-toggle="tooltip"]').length > 0 || target.closest('.tooltip').length > 0) {
        // ignore
    }
    else {
        $('[data-trigger="manual"]').tooltip('hide');
    }
});
export default undefined;
